module.exports = __webpack_public_path__ + "media/images/diy/led_uplight_bg-43eaaefcc75c2d13143b16c21f346dbd.svg";